import React from 'react'

function TeamNav({
    selectedTab,
    selectTab,
}) {
    return (
        <div className="dash-nav">
            <ul>
                <li><a href="javascript:;"
                    onClick={ () => selectTab('admin')}
                    className={selectedTab === 'admin' ? "active" : ""}>Admin view</a></li>
                <li><a href="javascript:;"
                    onClick={ () => selectTab('personal')}
                    className={selectedTab === 'personal' ? "active" : ""}>Personal view</a></li>
            </ul>
        </div>
    )
}

export default TeamNav


// WEBPACK FOOTER //
// ./src/components/layout/team_nav.jsx